import {
    FulltextResultWrapperProps,
    FulltextResultWrapperWithIcons,
    default as Wrapper,
} from '~/components/organisms/fulltext/fulltextSingleResult/FulltextResultWrapper';
import styles from './fulltextResultAtletika.module.scss';

const FulltextResultWrapper = ({ children, hasIcons, ...HTMLAttributes }: FulltextResultWrapperProps) =>
    hasIcons ? (
        <FulltextResultWrapperWithIcons {...HTMLAttributes} className={styles.serpResultWithIconAtletika}>
            {children}
        </FulltextResultWrapperWithIcons>
    ) : (
        <Wrapper hasIcons={false} {...HTMLAttributes}>
            {children}
        </Wrapper>
    );

export default FulltextResultWrapper;
